import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import axios from 'axios';
import Sidebar from '../../components/Admin/Sidebar'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ChangePassword = () => {
  const navigate = useNavigate();

  const [currentpassword, setcurrentpassword] = useState('');
  const [newpassword, setnewpassword] = useState('');
  const [confirmnewpassword, setconfirmnewpassword] = useState('');

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
  const [toggleValue, setToggleValue] = useState(false);

  const email = localStorage.getItem('email');

  const forgotpassword = async () => {
    if (currentpassword === '') {
      toast.error('Please enter your Current Password!');
      return;
    }

    if (newpassword === '') {
      toast.error('Please enter your New Password!');
      return;
    }
    if (confirmnewpassword === '') {
      toast.error('Please enter your Confirm New Password!');
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}auth/changepassword`, {
        currentpassword,
        newpassword,
        confirmnewpassword,
        email,
      });

      if (response.data.status === 'error') {
        toast.error(response.data.message);
      } else {
        toast.success(response.data.message);
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    } catch (err) {
      toast.error('Error Changing the Password!');
      console.error('Error:', err);
    }
  };

  return (

    <div className="container-fluid structure-background" style={{ padding: 0, margin: 0 }}>
      <div className="row w-100" style={{ margin: 0, padding: 0 }}>

        {/* Sidebar */}
        <div className="col-lg-2 p-0 bg-dark">
          <Sidebar toggleSidebar={toggleValue} setToggleValue={setToggleValue} />
        </div>

        {/* Main Content */}
        <div className="col-lg-10 dashboard-wrapper" style={{ padding: 0, margin: 0 }}>
          <Icon.ArrowRight
            onClick={() => setToggleValue(true)}
            className='my-3 ms-3 sidebar-open'
            color='black'
            size={30}
            style={{ cursor: 'pointer' }}
          />

          {/* Centered Form */}
          <div
            className="d-flex justify-content-center align-items-center vh-100"
            style={{ position: 'relative' }}
          >
            <div
              className="login-form"
              style={{
                backgroundColor: '#fff',
                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                padding: '20px',
                borderRadius: '8px',
                maxWidth: '400px',
                width: '100%',
              }}
            >
              <h6
                style={{
                  marginBottom: '20px',
                  fontWeight: 'bold',
                  color: '#6c757d',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Icon.Lock style={{ marginRight: '8px' }} />
                Change Password
              </h6>

              {/* Current Password */}
              <div style={{ marginBottom: '15px', position: 'relative' }}>
                <input
                  type={showCurrentPassword ? 'text' : 'password'}
                  className="form-control shadow-none"
                  placeholder="Current Password"
                  style={{ padding: '10px', fontSize: '0.9rem' }}
                  value={currentpassword}
                  onChange={(e) => setcurrentpassword(e.target.value)}
                />
                <Icon.EyeSlashFill
                  onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    fontSize: '20px',
                  }}
                  className={showCurrentPassword ? 'd-none' : ''}
                />
                <Icon.EyeFill
                  onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    fontSize: '20px',
                  }}
                  className={!showCurrentPassword ? 'd-none' : ''}
                />
              </div>

              {/* New Password */}
              <div style={{ marginBottom: '15px', position: 'relative' }}>
                <input
                  type={showNewPassword ? 'text' : 'password'}
                  className="form-control shadow-none"
                  placeholder="New Password"
                  style={{ padding: '10px', fontSize: '0.9rem' }}
                  value={newpassword}
                  onChange={(e) => setnewpassword(e.target.value)}
                />
                <Icon.EyeSlashFill
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    fontSize: '20px',
                  }}
                  className={showNewPassword ? 'd-none' : ''}
                />
                <Icon.EyeFill
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    fontSize: '20px',
                  }}
                  className={!showNewPassword ? 'd-none' : ''}
                />
              </div>

              {/* Confirm New Password */}
              <div style={{ marginBottom: '20px', position: 'relative' }}>
                <input
                  type={showConfirmNewPassword ? 'text' : 'password'}
                  className="form-control shadow-none"
                  placeholder="Confirm New Password"
                  style={{ padding: '10px', fontSize: '0.9rem' }}
                  value={confirmnewpassword}
                  onChange={(e) => setconfirmnewpassword(e.target.value)}
                />
                <Icon.EyeSlashFill
                  onClick={() => setShowConfirmNewPassword(!showConfirmNewPassword)}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    fontSize: '20px',
                  }}
                  className={showConfirmNewPassword ? 'd-none' : ''}
                />
                <Icon.EyeFill
                  onClick={() => setShowConfirmNewPassword(!showConfirmNewPassword)}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    fontSize: '20px',
                  }}
                  className={!showConfirmNewPassword ? 'd-none' : ''}
                />
              </div>

              {/* Update Password Button */}
              <div style={{ textAlign: 'center' }}>
                <button
                  style={{
                    backgroundColor: '#28a745',
                    color: '#fff',
                    border: 'none',
                    padding: '10px 20px',
                    fontSize: '1rem',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    width: '100%',
                  }}
                  onClick={forgotpassword}
                >
                  Update Password
                </button>
              </div>
            </div>
          </div>

          <ToastContainer theme="dark" autoClose={2000} />
        </div>
      </div>
    </div>

  );
};

export default ChangePassword;
